var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{class:{ disabled: _vm.is_hidden },attrs:{"href":_vm.brand + _vm.url,"target":"_blank"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }